import React from 'react';
import './ConversationList.css';

function ConversationList({
  conversations,
  selectedCustomer,
  onSelectCustomer,
  onNewConversation,
  onDeleteConversation
}) {
  const formatPhone = (phone) => {
    // Format phone number for display
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 11) {
      return `+${cleaned[0]} (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
    }
    return phone;
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  return (
    <div className="conversation-list">
      <div className="conversation-header">
        <h2>Conversations</h2>
        <button onClick={onNewConversation} className="new-conversation-btn">
          + New
        </button>
      </div>
      <div className="conversations">
        {conversations.length === 0 ? (
          <div className="no-conversations">
            <p>No conversations yet</p>
            <p className="hint">Click "+ New" to start messaging</p>
          </div>
        ) : (
          conversations.map((conv) => (
            <div
              key={conv.phone}
              className={`conversation-item ${selectedCustomer?.phone === conv.phone ? 'active' : ''}`}
              onClick={() => onSelectCustomer(conv)}
            >
              <div className="conversation-info">
                <div className="conversation-name">
                  {conv.name || formatPhone(conv.phone)}
                </div>
                <div className="conversation-phone">
                  {conv.name ? formatPhone(conv.phone) : ''}
                </div>
                {conv.order_number ? (
                  <div className="conversation-order">
                    Order #{conv.order_number}
                  </div>
                ) : null}
              </div>
              <div className="conversation-meta">
                {conv.unread_count > 0 ? (
                  <div className="unread-indicator" title="Unread messages" />
                ) : null}
                <div className="last-message">
                  {conv.last_message?.substring(0, 30)}
                  {conv.last_message?.length > 30 ? '...' : ''}
                </div>
                <div className="conversation-time">
                  {formatTime(conv.last_contact)}
                </div>
                <button
                  type="button"
                  className="conversation-delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteConversation?.(conv);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ConversationList;
